'use strict';

// Assigned Dependencies
module.exports = (function() {    
   $('.module-contact').find('.contact-toggle').click(function() {
        $(this).parent().find('.contact-forms').slideToggle();
        $(this).toggleClass('active');
        moveWindowToElement($(this).parent().find('.contact-forms'), 0,800);
   });
})();